// document.addEventListener('DOMContentLoaded', function () {

//   function initProductDescriptionAccordion() {

//     const descriptions = document.querySelectorAll(
//       '.t4s-tab-content, .t4s-product__description, [data-product-description]'
//     );

//     descriptions.forEach(function (description) {

//       if (description.dataset.h4Accordion === 'true') return;

//       const headings = description.querySelectorAll('h4');

//       if (!headings.length) return;

//       description.dataset.h4Accordion = 'true';

//       headings.forEach(function (heading) {

//         heading.classList.add('kalles-h4-accordion-title');

//         const content = document.createElement('div');
//         content.className = 'kalles-h4-accordion-content';

//         let element = heading.nextSibling;

//         while (element) {

//           const nextElement = element.nextSibling;

//           if (
//             element.nodeType === 1 &&
//             element.tagName.toLowerCase() === 'h4'
//           ) {
//             break;
//           }

//           content.appendChild(element);

//           element = nextElement;
//         }

//         heading.parentNode.insertBefore(
//           content,
//           heading.nextSibling
//         );

//         heading.addEventListener('click', function () {

//           const isOpen = heading.classList.contains('active');

//           heading.classList.toggle('active', !isOpen);
//           content.classList.toggle('active', !isOpen);

//         });

//       });

//     });

//   }

//   initProductDescriptionAccordion();

//   // Kalles AJAX / dynamic content
//   const observer = new MutationObserver(function () {
//     initProductDescriptionAccordion();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// });



document.addEventListener('DOMContentLoaded', function () {

  function initProductDescriptionAccordion() {

    const descriptions = document.querySelectorAll(
      '.t4s-tab-content, .t4s-product__description, [data-product-description]'
    );

    descriptions.forEach(function (description) {

      if (description.dataset.h4Accordion === 'true') return;

      const headings = description.querySelectorAll('h4');

      if (!headings.length) return;

      description.dataset.h4Accordion = 'true';

      headings.forEach(function (heading) {

        heading.classList.add('kalles-h4-accordion-title');

        const content = document.createElement('div');
        content.className = 'kalles-h4-accordion-content';

        let element = heading.nextSibling;

        while (element) {

          const nextElement = element.nextSibling;

          if (
            element.nodeType === 1 &&
            element.tagName.toLowerCase() === 'h4'
          ) {
            break;
          }

          content.appendChild(element);

          element = nextElement;
        }

        heading.parentNode.insertBefore(
          content,
          heading.nextSibling
        );

        heading.addEventListener('click', function (e) {

          e.preventDefault();
          e.stopPropagation();

          const isOpen = heading.classList.contains('active');

          /* Close all other tabs */
          headings.forEach(function (otherHeading) {

            if (otherHeading !== heading) {

              otherHeading.classList.remove('active');

              const otherContent = otherHeading.nextElementSibling;

              if (
                otherContent &&
                otherContent.classList.contains(
                  'kalles-h4-accordion-content'
                )
              ) {
                otherContent.classList.remove('active');
              }

            }

          });

          /* Toggle clicked tab */
          heading.classList.toggle('active', !isOpen);
          content.classList.toggle('active', !isOpen);

        });

      });

    });

  }

  /* Initial load */
  initProductDescriptionAccordion();

  /* Kalles AJAX / dynamic content */
  const observer = new MutationObserver(function () {
    initProductDescriptionAccordion();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});











// document.addEventListener('DOMContentLoaded', function () {

//   function initProductDescriptionAccordion() {

//     const descriptions = document.querySelectorAll(
//       '.t4s-tab-content, .t4s-product__description, [data-product-description]'
//     );

//     descriptions.forEach(function (description) {

//       if (description.dataset.h4Accordion === 'true') return;

//       const headings = Array.from(description.querySelectorAll('h4'));

//       if (!headings.length) return;

//       description.dataset.h4Accordion = 'true';

//       /*
//        * Create Description accordion
//        * for content before the first H4
//        */
//       const firstHeading = headings[0];

//       const descriptionTitle = document.createElement('div');
//       descriptionTitle.className = 'kalles-h4-accordion-title kalles-description-title';
//       descriptionTitle.textContent = 'Description';

//       const descriptionContent = document.createElement('div');
//       descriptionContent.className = 'kalles-h4-accordion-content';

//       /*
//        * Move content before first H4
//        * inside Description accordion
//        */
//       let element = description.firstChild;

//       while (element && element !== firstHeading) {

//         const nextElement = element.nextSibling;

//         descriptionContent.appendChild(element);

//         element = nextElement;
//       }

//       /*
//        * Insert Description accordion
//        */
//       description.insertBefore(descriptionTitle, firstHeading);
//       description.insertBefore(descriptionContent, firstHeading);

//       /*
//        * Convert H4 headings
//        */
//       headings.forEach(function (heading) {

//         heading.classList.add('kalles-h4-accordion-title');

//         const content = document.createElement('div');

//         content.className = 'kalles-h4-accordion-content';

//         let element = heading.nextSibling;

//         while (element) {

//           const nextElement = element.nextSibling;

//           if (
//             element.nodeType === 1 &&
//             element.tagName.toLowerCase() === 'h4'
//           ) {
//             break;
//           }

//           content.appendChild(element);

//           element = nextElement;
//         }

//         heading.parentNode.insertBefore(
//           content,
//           heading.nextSibling
//         );

//       });


//       /*
//        * Click event for ALL accordions
//        */
//       const allTitles = description.querySelectorAll(
//         '.kalles-h4-accordion-title'
//       );

//       allTitles.forEach(function (title) {

//         title.addEventListener('click', function (e) {

//           e.preventDefault();
//           e.stopPropagation();

//           const content = title.nextElementSibling;

//           if (
//             !content ||
//             !content.classList.contains(
//               'kalles-h4-accordion-content'
//             )
//           ) {
//             return;
//           }

//           const isOpen = title.classList.contains('active');


//           /*
//            * Close all other accordions
//            */
//           allTitles.forEach(function (otherTitle) {

//             otherTitle.classList.remove('active');

//             const otherContent =
//               otherTitle.nextElementSibling;

//             if (
//               otherContent &&
//               otherContent.classList.contains(
//                 'kalles-h4-accordion-content'
//               )
//             ) {
//               otherContent.classList.remove('active');
//             }

//           });


//           /*
//            * Open clicked accordion
//            */
//           if (!isOpen) {

//             title.classList.add('active');
//             content.classList.add('active');

//           }

//         });

//       });

//     });

//   }


//   /*
//    * Initial load
//    */
//   initProductDescriptionAccordion();


//   /*
//    * Kalles AJAX / dynamic content
//    */
//   const observer = new MutationObserver(function () {
//     initProductDescriptionAccordion();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// });


